import { styled, TableCell, TableRow, Typography } from '@mui/material';
import { CompletedReviewModel } from '../../lib/models/CompletedReviewModel';
import Moment from 'moment';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';
import Link from '../Utils/Link';

export type ClinicalReviewItemProps = {
    item: CompletedReviewModel;
};

const CompletedReviewItem = ({ item }: ClinicalReviewItemProps) => {
    const isLargerThanMedium = useScreenLargerThan('md');
    const TableDataCell = styled(TableCell)({
        borderBottom: 'none',
        paddingBottom: '0',
        verticalAlign: 'top',
        align: 'center',
        paddingLeft: isLargerThanMedium ? '1rem' : '0.313rem',
        paddingRight: isLargerThanMedium ? '1rem' : '0.313rem'
    });

    const TypographyMobileHeader = styled(Typography)({
        fontSize: 13,
        fontWeight: 600,
        color: '#979797'
    });

    const TypographyMobileText = styled(Typography)({
        fontSize: 14,
        fontWeight: 'bold'
    });

    return (
        <TableRow>
            <TableDataCell sx={{ width: isLargerThanMedium ? '' : '35%' }}>
                {!isLargerThanMedium && <TypographyMobileHeader>Date</TypographyMobileHeader>}
                <Typography sx={{ fontSize: 15, fontWeight: 400 }}>
                    {item.date != null ? Moment(item.date).format('MM/DD/YYYY ') : ''}
                </Typography>
                {!isLargerThanMedium && (
                    <TypographyMobileHeader>UM Review Minutes</TypographyMobileHeader>
                )}
                {!isLargerThanMedium && (
                    <TypographyMobileText>{item.reviewedMinutes}</TypographyMobileText>
                )}
            </TableDataCell>

            <TableDataCell sx={{ width: isLargerThanMedium ? '' : '37%' }}>
                {!isLargerThanMedium && (
                    <TypographyMobileHeader>Case Number</TypographyMobileHeader>
                )}

                <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                    {item.clinicalReviewId && item.crmId ? (
                        <Link
                            sx={{ textDecoration: 'none' }}
                            to={`/completedCaseDetails/${item.clinicalReviewId}/${item.crmId}`}>
                            {item.caseNumber}
                        </Link>
                    ) : (
                        item.caseNumber
                    )}
                </Typography>

                {!isLargerThanMedium && <TypographyMobileHeader>Case Stage</TypographyMobileHeader>}
                {!isLargerThanMedium && (
                    <TypographyMobileText>{item.caseStage}</TypographyMobileText>
                )}

                {!isLargerThanMedium && (
                    <TypographyMobileHeader>Case Category</TypographyMobileHeader>
                )}
                {!isLargerThanMedium && (
                    <TypographyMobileText>{item.caseCategory}</TypographyMobileText>
                )}
            </TableDataCell>

            {isLargerThanMedium && (
                <TableDataCell sx={{ fontWeight: 'bold' }}>{item.caseStage}</TableDataCell>
            )}

            {isLargerThanMedium && (
                <TableDataCell sx={{ fontWeight: 'bold' }}>{item.reviewedMinutes}</TableDataCell>
            )}

            {isLargerThanMedium && (
                <TableDataCell sx={{ fontWeight: 'bold' }}>{item.caseCategory}</TableDataCell>
            )}
        </TableRow>
    );
};

export default CompletedReviewItem;
